import { CatalogueBar } from './catalogue-bar';

export default CatalogueBar;
